define('view/controller/booking/datetime/slots-weekly/TimeSlotsWeeklyItemView',['require','view/controller/booking/datetime/slots/TimeSlotView','lib/view/UnwrapBehavior'],function (require) {

    var TimeSlotView = require('view/controller/booking/datetime/slots/TimeSlotView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Time slot item view
     *
     * @class TimeSlotsWeeklyItemView
     */
    return TimeSlotView.extend({

        template: '#time_slots_weekly_item_view',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        
        ui: {
            'freeCell': '.sb-cell.free'
        },
        
        triggers: {
            'click @ui.freeCell': 'select:time'
        },

        onShow: function () {
            if (this.model.get('type') === 'free') {
                var margin = this.$el.outerHeight(true) - this.$el.outerHeight();

                this.$el.css('height', (this.$el.outerHeight(true) * this.model.get('slots_count')) - margin);
            }
        }

    });

});
